import { createContext, useEffect, useState } from "react";
import { getEngTasks } from "../services/EtService";
import { environment } from "../../../environments/environment";

export const EtContext = createContext();

export const EtProvider = ({children}) => {
    const [items, setItems] = useState([]);

    useEffect(()=>{
        getEngTasks(0, "", environment.ElemensPerPage).then(response => {
            if (response.data.responseCode === 200) {
                console.warn("*et_elements", response.data.load);
                setItems(response.data.load);
            }
        })
    },[])

    return (
        <EtContext.Provider value={{items}}>
            {children}
        </EtContext.Provider>
    )

}